export const tiposInmueble = [
  {Id:'C', Nombre: "CASA-HABITACION"},
  {Id:'D', Nombre: "DEPARTAMENTO CONDOMINIO"},
  {Id:'F', Nombre: "OFICINA"},
  {Id:'L', Nombre: "LOCAL COMERCIAL"},
  {Id:'O', Nombre: "OTRO"},
  {Id:'T', Nombre: "TERRENO"},
]
